import { useRef } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { ReactComponent as InfoIcon } from "../assets/icons/info.svg";
import { ReactComponent as LeftChevronIcon } from "../assets/icons/left-arrow.svg";

export function Panel({
  actions,
  children,
  label,
  className = "",
  contentClassName = "",
  showHeader = true,
  showNavigation = false,
  id,
  style,
  infoTooltip,
  hasBorder = false,
  headerClassName = "",
}: {
  actions?: React.ReactNode;
  children: React.ReactNode;
  label: string | React.ReactNode;
  className?: string;
  contentClassName?: string;
  showHeader?: boolean;
  showNavigation?: boolean;
  id?: string;
  style?: React.CSSProperties;
  infoTooltip?: string;
  hasBorder?: boolean;
  headerClassName?: string;
}) {
  const tableRef = useRef<HTMLTableElement>(null);

  return (
    <div
      id={id}
      className={`relative w-full h-full min-h-0 flex flex-col overflow-hidden bg-surface-primary p-2 sm:p-3 rounded-lg shadow-soft border border-border-primary [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] ${className}`}
      onClick={(e) => e.stopPropagation()}
      style={{ ...style }}
    >
      {showHeader && (
        <div
          className={`header min-h-[48px] px-3 sm:px-4 py-1 flex justify-between items-center gap-2 sm:gap-0 flex-shrink-0 ${headerClassName}`}
        >
          <div className="flex items-center gap-2 w-full sm:w-auto">
            {typeof label === "string" ? (
              <div className="text-left justify-start text-content-primary text-base font-bold leading-none whitespace-nowrap mr-1">
                {label}
              </div>
            ) : (
              label
            )}
            {infoTooltip && (
              <>
                <div
                  className="cursor-pointer z-10"
                  data-tooltip-id={`tooltip-${id || "panel"}`}
                  data-tooltip-html={infoTooltip}
                >
                  <InfoIcon className="w-4 h-4 text-content-tertiary" />
                </div>
                <ReactTooltip
                  id={`tooltip-${id || "panel"}`}
                  className="w-[200px] z-[9999] !border border-border-secondary !text-content-primary !rounded-md !p-[11px] !bg-surface-primary !shadow-dropdown"
                  noArrow
                />
              </>
            )}
          </div>
          {actions && (
            <div className="w-full sm:w-auto flex justify-end">{actions}</div>
          )}
        </div>
      )}
      {hasBorder && <div className=" border-t border-border-primary"></div>}
      <div
        ref={tableRef}
        className={`flex-1 min-h-0 overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] ${contentClassName}`}
      >
        {children}

        {showNavigation && (
          <div
            className={`flex md:hidden absolute bottom-3 left-0 right-0 items-center gap-2 justify-center`}
          >
            <button
              type="button"
              onClick={() => tableRef.current?.scrollBy(-300, 0)}
              title={"left"}
              className="w-6 h-6 shadow-card flex justify-center items-center rounded border border-border-primary bg-gray-50"
            >
              <LeftChevronIcon className="w-4 h-4" />
            </button>
            <button
              type="button"
              onClick={() => tableRef.current?.scrollBy(300, 0)}
              title={"right"}
              className="w-6 h-6 shadow-card flex justify-center items-center rounded border border-border-primary bg-gray-50"
            >
              <LeftChevronIcon className="w-4 h-4 rotate-180" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
